import { useFunctionalityIndicatorsCommand } from "./hooks/useFunctionalityIndicatorsCommand.js";
import Textfield from "../../common/components/Textfiled";
import Button from "../../common/components/Button";

function RegisterFunctionalityIndicators() {
  const {
    indicators,
    handleChange,
    createIndicator,
    errors: { errors },
  } = useFunctionalityIndicatorsCommand();

  const handleSubmit = (event) => {
    event.preventDefault();
    createIndicator(indicators);
  };

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Registrar indicadores</h1>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3">
          <div className="w-100">
            <p>
              Formulario de registro de indicadores. Asegúrate de completar
              todos los campos requeridos.
            </p>
            <form onSubmit={handleSubmit}>
              <Textfield
                label="Fecha"
                type="date"
                name="date"
                value={indicators.date}
                onChange={handleChange}
                error={errors.date}
              />

              <Textfield
                label="Exceso de turnos diarios"
                placeholder="Exceso de turnos diarios"
                type="number"
                name="dailyWorkShiftExcesses"
                value={indicators.dailyWorkShiftExcesses}
                onChange={handleChange}
                error={errors.dailyWorkShiftExcesses}
              />

              <Textfield
                label="Total de días de trabajo del conductor"
                placeholder="Total de días de trabajo del conductor"
                type="number"
                name="totalDriverWorkDays"
                value={indicators.totalDriverWorkDays}
                onChange={handleChange}
                error={errors.totalDriverWorkDays}
              />

              <Textfield
                label="Viajes de trabajo con exceso de velocidad diarios"
                placeholder="Viajes de trabajo con exceso de velocidad diarios"
                type="number"
                name="dailySpeedingWorkTrips"
                value={indicators.dailySpeedingWorkTrips}
                onChange={handleChange}
                error={errors.dailySpeedingWorkTrips}
              />

              <Textfield
                label="Total de viajes de trabajo"
                placeholder="Total de viajes de trabajo"
                type="number"
                name="totalWorkTrips"
                value={indicators.totalWorkTrips}
                onChange={handleChange}
                error={errors.totalWorkTrips}
              />

              <Button type="submit">Registrar</Button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default RegisterFunctionalityIndicators;
